import { LinkedDepotList } from "./components/LinkedDepotList";

export default LinkedDepotList;